module.exports = __webpack_public_path__ + "img/grunge-stamp-360x360.72e4f534.png";